import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Account } from '@/types/types';

export const useAccount = (
  accountId: string | number,
  options?: Omit<UseQueryOptions<Account>, 'queryKey' | 'queryFn'>
) => {
  const { axiosInstance } = useApi();

  return useQuery({
    queryKey: queryKeys.accounts.detail(accountId).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Account>(`/api/v1/accounts/${accountId}`);
      return data;
    },
    ...options,
  });
};

export default useAccount;
